import React from 'react';

export function LargeRadioButton(props) {
    const elmId = Math.random().toString(36).substring(7);
    return (
        <div style={{ display: "inline" }}>
            <input readOnly
                id={elmId}
                type="radio"
                name={props.group}
                onClick={() => props.onClick()}
                checked={props.checked}
                disabled={props.disabled} />

            <label htmlFor={elmId}
                style={{ height: "max-content", ...props.labelStyle }}
                className={`radio-inline large ${props.className}`}>
                { props.children }
            </label>
        </div>
    );
}

LargeRadioButton.defaultProps = {
    checked: false,
    group: "",
    onClick: () => { },
    children: "Button",
    disabled: false,
    labelStyle: {},
    className: ""
}




// WEBPACK FOOTER //
// ./src/components/GenericComponets/LargeRadioButton.js